import { gql } from 'apollo-boost';

export const createProductMutation = gql`
  mutation createProductMutation($product: ProductCreateInput!) {
    product {
      create(product: $product) {
        id
        changedUtc
        sku
        isHazMat
        description
        rowVersion
        name
        packageTypeId
        pieceCount
        freightInfo {
          freightClassId
          nmfcItemCode
          nmfcSubCode
        }
        hazMat {
          contactEmail
          contactFirstName
          contactLastName
          contactPhone
          hazMatClassId
          hazMatPackingGroupId
          properShippingName
          unNumber
        }
        weightInfo {
          weight
          weightUnit
        }
        valueInfo {
          currency
          value
        }
      }
    }
  }
`;

export const updateProductMutation = gql`
  mutation updateProductMutation($product: ProductUpdateInput!) {
    product {
      update(product: $product) {
        id
        changedUtc
        sku
        isHazMat
        description
        rowVersion
        name
        packageTypeId
        pieceCount
        freightInfo {
          freightClassId
          nmfcItemCode
          nmfcSubCode
        }
        hazMat {
          contactEmail
          contactFirstName
          contactLastName
          contactPhone
          hazMatClassId
          hazMatPackingGroupId
          properShippingName
          unNumber
        }
        weightInfo {
          weight
          weightUnit
        }
        valueInfo {
          currency
          value
        }
      }
    }
  }
`;

export const deleteProductMutation = gql`
  mutation deleteProductMutation($productId: Int!) {
    product {
      delete(productId: $productId)
    }
  }
`;
